import type { SVGProps } from 'react'
const SvgSySignInCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle r={7} fillOpacity={0.24} transform="matrix(0 -1 -1 0 13 12)" />
		<path d="M11.146 9.146a.5.5 0 0 0 0 .708l1.647 1.646H4a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h8.793l-1.647 1.646a.5.5 0 0 0 0 .708.5.5 0 0 0 .708 0l2.5-2.5A.5.5 0 0 0 14.5 12a.5.5 0 0 0-.146-.354l-2.5-2.5a.5.5 0 0 0-.708 0" />
	</svg>
)
export default SvgSySignInCircle
